import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
  setReportData, 
  setLoading, 
  setSearchResults, 
  setEmployees, 
  setLocations, 
  setUsers, 
  setLoadingSearch 
} from './expenseRecordSlice';
import { postData } from '../../../apiservice/apis';
import { getAccountBySeachApi, getEmployeesApi, getLocationApi, getUserApi } from '../../../apiservice/setting';

export const fetchExpenseRecord = createAsyncThunk(
    'expenseRecord/fetchExpenseRecord',
    async (payload, { dispatch, getState }) => {
        try {
            dispatch(setLoading(true));

            let url = `/reports/get-expense-record`;

            if (payload.selectedRecordType?.recordType === "with details") {
                url = `/accounts/get-expense-with-details`;
            }

            if (payload.selectedFilterType?.filterType === "By Expense") {
                url = `/reports/get-expense-record-details`;
            }

            const reqPayload = {
                selectedFilterType: payload.selectedFilterType?.filterType,
                expId: payload.selectedExpense ? payload.selectedExpense.acc_id : null,
                employeeId: payload.selectedEmployee ? payload.selectedEmployee.employee_id : null,
                userId: payload.selectedUser ? payload.selectedUser.id : null,
                fromDate: payload.fromDate,
                toDate: payload.toDate,
            };

            const response = await postData(url, reqPayload);

            if (response.data) {
                let reportData = {};
                
                if (payload.selectedFilterType?.filterType === "By Expense") {
                    reportData.details = response.data;
                } else if (payload.selectedRecordType?.recordType === "with details") {
                    reportData.filterResultDetails = response.data;
                } else {
                    reportData.filterResult = response.data;
                }

                dispatch(setReportData(reportData));
            }

            return response.data;
        } catch (error) {
            console.error('Error fetching expense record:', error);
            throw error;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const searchExpenses = createAsyncThunk(
    'expenseRecord/searchExpenses',
    async (searchTerm, { dispatch, getState }) => {
        try {
            dispatch(setLoadingSearch(true));

            const response = await getAccountBySeachApi({
                query: searchTerm.trim(),
                type: "indirect_expense",
            });

            dispatch(setSearchResults(response.data || []));
            return response.data;
        } catch (error) {
            console.error('Error searching expenses:', error);
            throw error;
        } finally {
            dispatch(setLoadingSearch(false));
        }
    }
);

export const fetchEmployees = createAsyncThunk(
    'expenseRecord/fetchEmployees',
    async (_, { dispatch, getState }) => {
        try {
            const response = await getEmployeesApi(null);
            dispatch(setEmployees(response.data || []));
            return response.data;
        } catch (error) {
            console.error('Error fetching employees:', error);
            throw error;
        }
    }
);

export const fetchLocations = createAsyncThunk(
    'expenseRecord/fetchLocations',
    async (_, { dispatch, getState }) => {
        try {
            const response = await getLocationApi(null);
            dispatch(setLocations(response.data || []));
            return response.data;
        } catch (error) {
            console.error('Error fetching locations:', error);
            throw error;
        }
    }
);

export const fetchUsers = createAsyncThunk(
    'expenseRecord/fetchUsers',
    async (_, { dispatch, getState }) => {
        try {
            const response = await getUserApi({ "select-type": "active" });
            dispatch(setUsers(response.data.message || []));
            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    }
);